import { Component, inject } from '@angular/core';
import { BrandingManagerService } from '@rx-applications/shared/branding/data-access';
import { PhoneNumberInputComponent } from '../phone-number-input/phone-number-input.component';

@Component({
  selector: 'rx-applications-logo',
  standalone: true,
  imports: [PhoneNumberInputComponent],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
})
export class LogoComponent {
  logoImage = inject(BrandingManagerService).getBrandAccess().getLogoFullUrl();
  logoHeight = inject(BrandingManagerService).getBrandAccess().getLogoHeightInPx();
}
